import React, { memo, useState, useEffect } from 'react';
import { Flex, Carousel } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';

const SliderCell = memo((props) => {
  const [rate, setRate] = useState(23 / 20);
  const [nowPage, setNowPage] = useState(1);
  const {
    containerStyle, // Object 容器样式
    width, // any 容器宽度
    data: dataObj, // Object 数据源
    showBullets = true, // Boolean 是否显示轮播指示器
    onPress // Function 点击事件
  } = props;

  const {
    datas: data = [], // Array 数据
    filletValue = 0 // Number 圆角
  } = dataObj;

  useEffect(() => {
    if (data.length > 0) {
      const { imgInfo } = data[0];
      if (imgInfo && imgInfo.width && imgInfo.height) {
        setRate(imgInfo.width / imgInfo.height);
      } else {
        setRate(23 / 20);
      }
    }
  }, [data]);

  // 渲染轮播指示器
  const renderBullet = () => {
    if (!showBullets) return null;

    // banner的张数
    const length = data.length;

    // 指示器总宽度
    const viewW = '1.86rem';
    const nowW = `calc(${viewW} * (${nowPage} / ${length})`;

    return (
      <Flex
        direction="row"
        align="center"
        style={{
          width: viewW,
          height: '0.06rem',
          background: '#f5f7fa'
        }}>
        <Flex
          style={{
            width: nowW,
            height: '0.06rem',
            background: '#040404'
          }}
        />
      </Flex>
    );
  };

  return (
    <Flex
      direction="column"
      align="center"
      style={{
        ...containerStyle,
        borderRadius: `${(filletValue / 100) * 2}rem`
      }}>
      <Carousel
        style={{
          width,
          height: `calc(${width} / ${rate})`
        }}
        autoplay
        infinite
        dots={false}
        afterChange={(index) => setNowPage(index + 1)}>
        {data.map((item, index) => {
          const { imgInfo } = item;
          const { imgUrl } = imgInfo;

          return (
            <Flex key={index} onClick={() => onPress && onPress(item)}>
              <ImgWrap w={width} h={`calc(${width} / ${rate})`} src={imgUrl} mode="cover" />
            </Flex>
          );
        })}
      </Carousel>
      {renderBullet()}
    </Flex>
  );
});

export default SliderCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/SliderCell/index.js